function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Email MLR Status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 62",
    d: "M11774 2126a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6zm.828-4.242a.621.621 0 1 0 .585.828h1.277a.216.216 0 0 0 .18-.1.211.211 0 0 0 .006-.2l-.836-1.608a.4.4 0 0 0 .029-.16.413.413 0 1 0-.411.414.237.237 0 0 0 .045 0l.647 1.245h-.937a.623.623 0 0 0-.586-.419zm-2.48-1.86a.62.62 0 0 0-.621.618.605.605 0 0 0 .127.373l-.725 1.4a.21.21 0 0 0 .006.2.216.216 0 0 0 .178.1h1.5a.406.406 0 0 0 .357.207.414.414 0 1 0-.357-.621h-1.165l.547-1.052a.609.609 0 0 0 .148.021.621.621 0 0 0 0-1.242zm1.655-2.244.54 1.042a.6.6 0 0 0-.13.372.624.624 0 1 0 .476-.6l-.7-1.354a.209.209 0 0 0-.184-.112.2.2 0 0 0-.184.112l-.807 1.546a.232.232 0 0 0-.045 0 .409.409 0 0 0-.414.414.414.414 0 0 0 .828 0 .4.4 0 0 0-.032-.16l.652-1.255z",
    transform: "translate(-11768 -2114)",
    style: {
      fill: "#f26b2b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonStatus);
export default __webpack_public_path__ + "static/media/common_status.ee9107978876be3db31646243d163b2d.svg";
export { ForwardRef as ReactComponent };